import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import {
  GetOutOfPocketExpensesEnabledResponse,
  PutOutOfPocketExpensesFields,
  PutOutOfPocketExpensesRequest,
  PutOutOfPocketExpensesResponse,
} from 'src/queries/organizations/outOfPocketExpenses/outOfPocketExpenses.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

const toPutOutOfPocketExpensesRequest = (
  fields: PutOutOfPocketExpensesFields,
): PutOutOfPocketExpensesRequest => ({
  isVisible: fields.isVisible,
  expenseApproverId:
    fields.expenseApproverId === '' ? undefined : fields.expenseApproverId,
  mileageRate: Math.round((fields.mileageRate ?? 0) * 1000),
})

export const getOutOfPocketExpensesEnabled = async (
  orgId: string,
): Promise<GetOutOfPocketExpensesEnabledResponse> => {
  return getResponseData(
    axios.get<GetOutOfPocketExpensesEnabledResponse>(
      `/organizations/${orgId}/outofpocketexpenses`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const putOutOfPocketExpensesSettings = async (
  orgId: string,
  fields: PutOutOfPocketExpensesFields,
): Promise<PutOutOfPocketExpensesResponse> => {
  return getResponseData(
    axios.put<PutOutOfPocketExpensesResponse>(
      `/organizations/${orgId}/outofpocketexpenses`,
      toPutOutOfPocketExpensesRequest(fields),
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
